import { render, staticRenderFns } from "./SeaExperience.vue?vue&type=template&id=c5e5d5a4&scoped=true&"
import script from "./SeaExperience.vue?vue&type=script&lang=js&"
export * from "./SeaExperience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e5d5a4",
  null
  
)

export default component.exports